/**
 * @generated SignedSource<<c42ba3df79e9d79b9d4e9cc0668daa4d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LoginSamlField_company$data = {
  readonly preferences: {
    readonly core: {
      readonly authConfigs: ReadonlyArray<{
        readonly _id: string;
        readonly active: boolean | null | undefined;
        readonly buttonLabel: string | null | undefined;
        readonly id: string;
        readonly type: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly integration: {
        readonly microsoft: {
          readonly tenant: string | null | undefined;
        };
      };
      readonly login: {
        readonly enableSaml: boolean | null | undefined;
        readonly enableSaml2: boolean | null | undefined;
      };
    };
  };
  readonly " $fragmentType": "LoginSamlField_company";
};
export type LoginSamlField_company$key = {
  readonly " $data"?: LoginSamlField_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"LoginSamlField_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LoginSamlField_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CompanyPreferences",
      "kind": "LinkedField",
      "name": "preferences",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CompanyCorePreferences",
          "kind": "LinkedField",
          "name": "core",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "AuthConfig",
              "kind": "LinkedField",
              "name": "authConfigs",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "_id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "buttonLabel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "active",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CompanyCoreLoginPreferences",
              "kind": "LinkedField",
              "name": "login",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "enableSaml",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "enableSaml2",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CompanyIntegrationPreferences",
              "kind": "LinkedField",
              "name": "integration",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CompanyIntegrationMicrosoftPreferences",
                  "kind": "LinkedField",
                  "name": "microsoft",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "tenant",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "49a5d27cca364d6fc213c6ca25907433";

export default node;
